import React, { useState, useEffect, useContext } from "react";
import { FaCoins, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { Link } from "react-router";
import MainHeader from "../../Components/Header/MainHeader";
import AuthContext from "../../Store/AuthContext";
import styles from "./Profile.module.css";

const Profile = () => {
    const [user, setUser] = useState(null);
    const [points, setPoints] = useState(0);
    const [orderHistory, setOrderHistory] = useState([]);
    const [redemptionHistory, setRedemptionHistory] = useState([])
    const authCtx = useContext(AuthContext)

    useEffect(() => {
        // Simulated API response
        const sampleData = {
            user: {
                name: "John Doe",
                email: "john.doe@example.com",
                phone: "+1 234 567 890",
                avatar: "https://randomuser.me/api/portraits/men/45.jpg", // Sample avatar
            },
            points: 1250, // User's available points
            orders: [
                {
                    id: "ORD12345",
                    product: "Wireless Headphones",
                    date: "2024-02-01",
                    status: "Delivered",
                },
                {
                    id: "ORD12346",
                    product: "Smartphone Case",
                    date: "2024-01-28",
                    status: "Shipped",
                },
                {
                    id: "ORD12347",
                    product: "Gaming Mouse",
                    date: "2024-01-15",
                    status: "Cancelled",
                },
            ],
            redemptions: [
                {
                    id: "RED45678",
                    item: "Amazon Gift Card - $10",
                    date: "2024-02-05",
                    status: "Redeemed",
                },
                {
                    id: "RED45679",
                    item: "Starbucks Voucher - $5",
                    date: "2024-01-20",
                    status: "Processing",
                },
            ],
        };

        setUser(sampleData.user);
        setPoints(sampleData.points);
        setOrderHistory(sampleData.orders);
        setRedemptionHistory(sampleData.redemptions);
    }, []);


    if (!user) return <div className={styles.loading}>Loading...</div>;

    return (
        <div>
            <MainHeader />

            <div className={styles.mainWrapper}>
                <div className={styles.leftWrapper} >
                    <div className={styles.profileHeader}>
                        <img
                            src={user.avatar || "/default-avatar.png"}
                            alt="Profile"
                            className={styles.profileImage}
                        />
                        <div className={styles.userInfo}>
                            <h2>{user.name}</h2>
                            <p>Email: {user.email}</p>
                            <p>Phone: {user.phone}</p>
                        </div>
                    </div>
                    <div>
                        <div className={styles.accountDetailsTitle}>
                            Account Details
                        </div>
                        <div className={styles.navWrapper}>
                            <Link to={`/profile`} className={styles.eachNavOption}>
                                <FaUser size={18} /> Profile 
                            </Link> 
                            <Link to={`/orders`} className={styles.eachNavOption}>
                                <FaShoppingCart size={18} /> Orders     
                            </Link>
                            <Link to={`/points`} className={styles.eachNavOption}>
                                <FaCoins size={18} /> Loyalty Points
                            </Link>

                            <button onClick={() => authCtx.logout() } className={styles.logoutBtn} >
                                <MdLogout size={18}  /> Logout
                            </button>

                        </div>
                    </div>
                </div>
                <div className={styles.rightWrapper}>
                    <div className={styles.profileContainer}>

                        <div className={styles.section}>
                            <h3>Points Balance</h3>
                            <p className={styles.points}>{points} Points</p>
                        </div>

                        <div className={styles.section}>
                            <h3>Order History</h3>
                            <ul>
                                {orderHistory.length > 0 ? (
                                    orderHistory.map((order) => (
                                        <li key={order.id} className={styles.orderItem}>
                                            <strong>{order.product}</strong> - {order.date} - {order.status}
                                        </li>
                                    ))
                                ) : (
                                    <p>No orders found.</p>
                                )}
                            </ul>
                        </div>

                        <div className={styles.section}>
                            <h3>Redemption History</h3>
                            <ul>
                                {redemptionHistory.length > 0 ? (
                                    redemptionHistory.map((redemption) => (
                                        <li key={redemption.id} className={styles.redemptionItem}>
                                            <strong>{redemption.item}</strong> - {redemption.date} -{" "}
                                            {redemption.status}
                                        </li>
                                    ))
                                ) : (
                                    <p>No redemptions found.</p>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
